<div class="auth-wrapper" style="background: #fff !important;">
  <div class="auth-content">
    <div class="row my-auto">
      <div class="col-lg-12 col-md-12 col-sm-12 text-center align-items-center">
        <img width="850" src="assets/images/page404.svg" alt="">
      </div>
    </div>
  </div>
</div>
